import { useGetParams } from '../../hooks/useGetParams';
import styles from './VariantImg.module.css';
import { motion } from 'framer-motion';

export const VariantImg = ({ item, index, aciveAmimate }) => {
  const { answerFontSize, varNumFontSize } = useGetParams();

  const variants = {
    inactive: {
      border: '0.3rem solid #93e2ff',
      backgroundImage:
        'linear-gradient(0deg,rgba(7, 71, 225, 1),rgba(34, 47, 78, 0.63))',
    },
    active: {
      border: '0.3rem solid #F89F05',
      backgroundImage:
        'linear-gradient(0deg, rgba(255, 31, 0, 1), rgba(34, 47, 78, 0.63))',
    },
  };

  const numberVariants = {
    inactive: {
      backgroundImage: 'linear-gradient(90deg, #39b3f8, #0942d2)',
    },
    active: {
      backgroundImage: 'linear-gradient(90deg, #F38804, #DE1B00)',
    },
  };

  return (
    <div className={styles.variant}>
      <motion.div
        variants={variants}
        initial="inactive"
        animate={aciveAmimate ? 'active' : 'inactive'}
        transition={{ duration: 0.5, delay: 1 }}
        className={styles.variantImgBlock}
      >
        <motion.div
          variants={numberVariants}
          initial="inactive"
          animate={aciveAmimate ? 'active' : 'inactive'}
          transition={{ duration: 0.5, delay: 1 }}
          className={styles.varNumber}
          style={{
            fontSize: `${varNumFontSize}rem`,
            height: `${1.8 * varNumFontSize}rem`,
            width: `${1.8 * varNumFontSize}rem`,
            minWidth: `${1.8 * varNumFontSize}rem`,
          }}
        >
          {index + 1}
        </motion.div>

        {item.varImgUrl && <img src={item.varImgUrl} alt="varImgUrl" />}
      </motion.div>

      <motion.div className={styles.varTitle}>{item.comment}</motion.div>
    </div>
  );
};
